import "./Central3CX.module.css";
import Header from "@/reusable_sections/Header";
import Hero3cxEnterprise from "./sections/Hero3cxEnterprise";
import KeyFeaturesGrid from "./sections/KeyFeaturesGrid";
import DeploymentFlexibility from "./sections/DeploymentFlexibility";
import WhyChoose3cx from "./sections/WhyChoose3cx";
import TrustedByLeadingCompanies from "./sections/TrustedByLeadingCompanies";
import FinalCtaStartFreeTrial from "./sections/FinalCtaStartFreeTrial";
import Footer from "@/reusable_sections/Footer";
export default function Central3CXPage() {
  return <div>
      <Header />
      <Hero3cxEnterprise />
      <KeyFeaturesGrid />
      <DeploymentFlexibility />
      <WhyChoose3cx />
      <TrustedByLeadingCompanies />
      <FinalCtaStartFreeTrial />
      <Footer />
    </div>;
}